export default __webpack_public_path__ + "static/1024-79e66685de8a4f4fb4aed6e1b1617f1a.gif";